module.exports = __webpack_public_path__ + "img/map-3.8b69fb22.svg";